<template>
  <div class="home-layout">
    <main-header></main-header>
    <router-view></router-view>
  </div>
</template>

<script>
import MainHeader from "../components/Parts/MainHeader";

/**
 * Component Home.vue
 *
 * @module Home
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/layout/Home.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'Home',
  components: {
    MainHeader,
  },
};
</script>

<style lang="scss">
.home-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .standard-layout {
    padding: 24px 4px 24px 4px;
  }

  .standard-layout__heading {
    line-height: 2;
  }
}

.c-grey-btn {
  background-color: #f6f6f8 !important;
  padding: 0 32px !important;
  border: 0;

  .v-btn__content {
    color: rgba(0, 0, 0, 0.87) !important;
  }
}

.v-application.md-up {
  .home-layout {
    .standard-layout {
      padding: 24px 12px 24px 18px;
    }
  }
}
</style>
